angular.module('app').directive('apToolbar', ['$rootScope', '$transitions', 'AppRoutes', 'NotificationRepository', 'GuidList', 'PatientSettingsService', 'NotificationService', 'PatientPortalStorageRepository', 'TransitionManager',
    function ($rootScope, $transitions, AppRoutes, NotificationRepository, GuidList, PatientSettingsService, NotificationService, PatientPortalStorageRepository, TransitionManager) {
        'use strict';

        return {
            restrict: 'E',
            templateUrl: '/app/partials/toolbar/views/apToolbar.html',
            scope: true,
            transclude: false,
            link: function (scope) {

                scope.blankToolbar = {
                    IsActive: false,
                    BackToHome: { IsActive: false}
                };
                var featureList = PatientSettingsService.getPatientFeatures();
                scope.notifications = {
                    Welcome: { BadgeCount: 0, IsActive: true},
                    Chart: { BadgeCount: 0, IsActive: true},
                    Messages: { BadgeCount: 0, IsActive: featureList.SendReceiveMessages.IsActive},
                    Forms: { BadgeCount: 0, IsActive: true},
                    Prescriptions: { BadgeCount: 0, IsActive: featureList.RequestRxRefills.IsActive},
                    Appointments: { BadgeCount: 0, IsActive: featureList.ViewAppointments.IsActive},
                    Billing: { BadgeCount: 0, IsActive: (featureList.ViewPatientStatement.IsActive || featureList.ViewPatientLedger.IsActive || featureList.MakeAPayment)},
                    Doctors: { BadgeCount: 0, IsActive: false}    // TODO - Implement Doctor pages
                };

                function getNotifications() {
                    if (!!$rootScope.hideToolbar) {
                        return;
                    }

                    var activePatientId = PatientPortalStorageRepository.getActivePatient().id;
                    if (activePatientId) {
                        NotificationRepository
                            .getNotifications(activePatientId)
                            .then(function (notifications) {
                                featureList = PatientSettingsService.getPatientFeatures();

                                scope.notifications.Chart.BadgeCount = _.find(notifications, {NotificationType: 'Chart'}).Count;

                                scope.notifications.Messages.BadgeCount = _.find(notifications, {NotificationType: 'Messages'}).Count;
                                scope.notifications.Messages.IsActive = featureList.SendReceiveMessages.IsActive;

                                scope.notifications.Forms.BadgeCount = _.find(notifications, {NotificationType: 'Forms'}).Count; 
                                scope.notifications.Forms.IsActive = true;

                                scope.notifications.Prescriptions.BadgeCount = _.find(notifications, {NotificationType: 'Prescriptions'}).Count;
                                scope.notifications.Prescriptions.IsActive = featureList.RequestRxRefills.IsActive;

                                scope.notifications.Appointments.BadgeCount = _.find(notifications, {NotificationType: 'Appointments'}).Count;
                                scope.notifications.Appointments.IsActive = featureList.ViewAppointments.IsActive;

                                scope.notifications.Billing.BadgeCount = _.find(notifications, {NotificationType: 'Billing'}).Count;
                                scope.notifications.Billing.IsActive = (featureList.ViewPatientStatement.IsActive || featureList.ViewPatientLedger.IsActive || featureList.MakeAPayment.IsActive);

                                scope.notifications.Doctors.BadgeCount = _.find(notifications, {NotificationType: 'Doctors'}).Count;
                            });
                    }
                }

                getNotifications();

                function loadToolbar() {
                    if (!!$rootScope.hideToolbar) {
                        return;
                    }
                    NotificationService.startNotificationTimer();
                }

                loadToolbar();

                //var notificationListener = scope.$on('Notification:updated', function (event, data)  {
                var notificationListener = scope.$on('Notification:updated', function () {
                    getNotifications();
                });

                var stateChangeListener = $transitions.onSuccess({}, function onTransitionSuccess(transition) {
                    var toState = transition.targetState() || {};
                    var toStateName = toState && toState.name() || '';
                    var appRoute = AppRoutes.findByStateName(toStateName);
                    scope.toolbarItem = (appRoute && appRoute.portalSettings && appRoute.portalSettings.toolbarItem);

                    if (scope.toolbarItem === 'blank') {
                        _.forEach(scope.notifications, function (toolbarButton) {
                            toolbarButton.IsActive = false;
                        });

                        scope.blankToolbar.IsActive = true;
                        scope.blankToolbar.BackToHome.IsActive = true;
                    }
                    else {
                        if (scope.blankToolbar.IsActive) {
                            resetToolbarState();
                        }
                    }
                });

                scope.$on('$destroy', function () {
                    notificationListener();
                    stateChangeListener();
                    NotificationService.stopNotificationTimer();
                });


                function resetToolbarState() {
                    scope.blankToolbar.IsActive = false;
                    scope.blankToolbar.BackToHome.IsActive = false;

                    scope.notifications.Welcome.IsActive = true;
                    scope.notifications.Chart.IsActive = true;
                    scope.notifications.Doctors.IsActive = false;

                    var featureList = PatientSettingsService.getPatientFeatures();
                    scope.notifications.Messages.IsActive = featureList.SendReceiveMessages.IsActive;
                    scope.notifications.Forms.IsActive = true;
                    scope.notifications.Prescriptions.IsActive = featureList.RequestRxRefills.IsActive;
                    scope.notifications.Appointments.IsActive = featureList.ViewAppointments.IsActive;
                    scope.notifications.Billing.IsActive = (featureList.ViewPatientStatement.IsActive || featureList.ViewPatientLedger.IsActive || featureList.MakeAPayment);
                }


                function backToHome() {
                    //getNotifications();
                    resetToolbarState();
                    TransitionManager.transition({appRoute: 'dashboard'});
                }

                function navigateToChart() {
                    var activePatientId = PatientPortalStorageRepository.getActivePatient().id;
                    var targetAppRoute;
                    var opts = {
                        id: activePatientId,
                    };
                    if (featureList.ViewClinicalSummary.IsActive) {
                        targetAppRoute = 'myChartVisitSummary';
                    } else if (featureList.ViewMedicalHistory.IsActive) {
                        targetAppRoute = 'myChartProblems';
                    } else if (featureList.ViewMedications.IsActive) {
                        targetAppRoute = 'myChartPrescriptions';
                    } else if (featureList.ViewProcedures.IsActive) {
                        targetAppRoute = 'myChartProcedures';
                    } else if (featureList.ViewLabTestResults.IsActive) {
                        targetAppRoute = 'myChartLabResults';
                    } else if (featureList.ViewImmunizations.IsActive) {
                        targetAppRoute = 'myChartImmunizations';
                    } else if (featureList.ViewEducationMaterial.IsActive) {
                        targetAppRoute = 'myChartReferenceMaterial';
                    } else if (featureList.ViewMedicationAllergies.IsActive) {
                        targetAppRoute = 'myChartMedicationAllergies';
                    } else {
                        targetAppRoute = 'myChartPersonalDetails';
                    }

                    TransitionManager.transition({
                        appRoute: targetAppRoute,
                        opts: opts,
                    });
                }

                scope.backToHome = backToHome;
                scope.navigateToChart = navigateToChart;

            }
        };
    }]);